import React from 'react';

interface RobustRoomImageProps {
  roomId: string | number;
  index?: number;
  fallbackUnsplashUrl?: string;
  alt: string;
  className?: string;
  loading?: 'lazy' | 'eager';
}

export default function RobustRoomImage({
  roomId,
  index = 0,
  fallbackUnsplashUrl,
  alt,
  className = '',
  loading = 'lazy'
}: RobustRoomImageProps) {
  // Determine the correct local path based on room ID and slide index
  let imgSrc = '/gallery/rooms/double_room.jpg';
  
  const rId = String(roomId || '').toLowerCase();
  
  if (rId.includes('double') || rId.includes('private')) {
    if (index === 1) imgSrc = '/gallery/rooms/double_slide1.jpg';
    else if (index === 2) imgSrc = '/gallery/rooms/double_slide2.jpg';
    else imgSrc = '/gallery/rooms/double_room.jpg';
  } else if (rId.includes('eight') || rId.includes('8')) {
    if (index === 1) imgSrc = '/gallery/rooms/eight_slide1.jpg';
    else if (index === 2) imgSrc = '/gallery/rooms/eight_slide2.jpg';
    else imgSrc = '/gallery/rooms/eight_bed.jpg';
  } else if (rId.includes('women') || rId.includes('female')) {
    if (index === 1) imgSrc = '/gallery/rooms/four_slide1_womens.jpg';
    else if (index === 2) imgSrc = '/gallery/rooms/four_slide2_womens.jpg';
    else imgSrc = '/gallery/rooms/four_bed_womens.jpg';
  } else if (rId.includes('men') || rId.includes('male')) {
    if (index === 1) imgSrc = '/gallery/rooms/four_slide1_mens.jpg';
    else if (index === 2) imgSrc = '/gallery/rooms/four_slide2_mens.jpg';
    else imgSrc = '/gallery/rooms/four_bed_mens.jpg';
  } else if (rId.includes('six') || rId.includes('6')) {
    if (index === 1) imgSrc = '/gallery/rooms/six_slide1.jpg';
    else if (index === 2) imgSrc = '/gallery/rooms/six_slide2.jpg';
    else imgSrc = '/gallery/rooms/six_bed.jpg';
  } else if (fallbackUnsplashUrl && !fallbackUnsplashUrl.includes('unsplash')) {
    imgSrc = fallbackUnsplashUrl;
  }

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      loading={loading}
      decoding="async"
      onError={(e) => {
        // Ultimate fallback to prevent broken box if a path fails
        (e.target as HTMLImageElement).src = '/gallery/rooms/double_room.jpg';
      }}
    />
  );
}
